module.exports = __webpack_public_path__ + "static/media/tbluff.805e20ed.gif";